import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { initialState } from '@/modules/services/dailyCut/store/dailyCutDetailsSlice/initialState.ts'

const dailyCutDetailSlice = createSlice({
  name: 'dailyCutDetail',
  initialState,
  reducers: {
    setFilters: (state, action: PayloadAction<string>) => {
      state.filters = action.payload
    },
    reset: () => initialState
  }
})

export const dailyCutDetailActions = dailyCutDetailSlice.actions
export const { reducer: dailyCutDetailReducer } = dailyCutDetailSlice
